import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '@/utilities/auth'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
      meta: {
        requiresAuth: true,
        icon:'home',
        pageTitle: 'Ana Sayfa',
        
      },
    },
    {
      path: '/Auth/Login',
      name: 'login',
      component: () => import('@/views/auth/LoginView.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/Profile',
      name: 'profile',
      component: () => import('@/views/profile/ProfileView.vue'),
      meta: {
        requiresAuth: true,
        icon: 'account_circle',
        pageTitle: 'Profil Yönetimi',
        breadcrumb: [
          {
            text: 'Profil Yönetimi',
            active: true,
          }
        ],
      },
    },
    {
      path: '/Activation/:code',
      name: 'activate',
      component: () => import('@/views/auth/ActivateView.vue'),
      meta: {
        layout: 'full',
        contentClass:'d-flex align-items-center justify-content-center h-100'
      },
    },
    {
      path:'/Payment/:code',
      name:'payment',
      component: () => import('@/views/payment/PaymentView.vue'),
      meta: {
        requiresAuth: true,
        layout: 'full',
        contentClass:'p-1',
      },
    },
    {
      path:'/PaymentsReport',
      name:'payments',
      component: () => import('@/views/payment-reports/payments/PaymentReportView.vue'),
      meta: {
        // requiresRole:["REPORT_PAYMENT_LIST"],
        requiresAuth: true,
        icon: 'payments',
        pageTitle: 'Ödemeler',
        breadcrumb: [
          {
            text: 'Ödemeler',
            active: true,
          },
        ],
      },
    },
    {
      path:'/:code',
      name:'paymentroute',
      component: () => import('@/views/payment/PaymentRouteView.vue'),
      meta: {
        layout: 'full',
        contentClass:'p-1',
      },
    },
    {
      path:'/PaymentError/:paymentCode/:receiptCode',
      name:'payment-error',
      component: () => import('@/views/payment/PaymentErrorView.vue'),
      meta: {
        layout: 'full',
        contentClass:'d-flex align-items-center justify-content-center h-100'
      },
    },
    {
      path:'/Receipt/:code',
      name:'receipt',
      component: () => import('@/views/receipt/ReceiptView.vue'),
      meta: {
        layout: 'full',
        contentClass:'p-1',
      },
    },
    {
      path:'/SystemManagement/BankIntegration',
      name:'bank-integration',
      component: () => import('@/views/bank-integration/BankIntegrationView.vue'),
      meta: {
        requiresRole:["bank.parameters.management"],
        requiresAuth: true,
        icon: 'account_balance',
        pageTitle: 'Banka Entegrasyonu',
        breadcrumb: [
          {
            text: 'Banka Entegrasyonu',
            active: true,
          }
        ],
      },
    },
    // {
    //   path:'/SystemParameter',
    //   name:'system-parameter',
    //   component: () => import('@/views/system-parameter/SystemParameterView.vue'),
    //   meta: {
    //     // requiresRole:["SYSTEM_PARAMETER_OPERATIONS"],
    //     requiresAuth: true,
    //     icon: 'dns',
    //     pageTitle: 'Sistem Parametreleri',
    //     breadcrumb: [
    //       {
    //         text: 'Sistem Parametreleri',
    //         active: true,
    //       }
    //     ],
    //   },
    // },
    {
      path:'/SystemManagement/User',
      name:'user',
      component: () => import('@/views/user/UserView.vue'),
      meta: {
        requiresRole:["user.management"],
        requiresAuth: true,
        icon: 'people',
        pageTitle: 'Sistem Yönetimi',
        breadcrumb: [
          {
            text: 'Kullanıcılar',
            active: true,
          }
        ],
      },
    },
    // {
    //   path:'/SystemManagement/MailSetting',
    //   name:'mail-setting',
    //   component: () => import('@/views/mail-setting/MailSettingView.vue'),
    //   meta: {
    //     // requiresRole:["MAIL_OPERATIONS"],
    //     requiresAuth: true,
    //     icon: 'mail_lock',
    //     pageTitle: 'E-Posta Ayarları',
    //     breadcrumb: [
    //       {
    //         text: 'Sistem Yönetimi',
    //         active: true,
    //       },
    //       {
    //         text: 'E-Posta Ayarları',
    //         active: true,
    //       }
    //     ],
    //   },
    // },
    // {
    //   path:'/SystemManagement/Role',
    //   name:'role',
    //   component: () => import('@/views/role/RoleView.vue'),
    //   meta: {
    //     // requiresRole:["ROLE_OPERATIONS"],
    //     requiresAuth: true,
    //     icon: 'settings_accessibility',
    //     pageTitle: 'Rol Yönetimi',
    //     breadcrumb: [
    //       {
    //         text: 'Sistem Yönetimi',
    //         active: true,
    //       },
    //       {
    //         text: 'Rol Yönetimi',
    //         active: true,
    //       }
    //     ],
    //   },
    // },
    {
      path:'/PaymentProcess/PaymentRequests',
      name:'sent-payment-request',
      component: () => import('@/views/payment-request/PaymentRequestView.vue'),
      meta: {
        requiresRole:["payment.request.list.view","payment.request.list.view.customer"],
        requiresAuth: true,
        icon: 'credit_card',
        pageTitle: 'Ödeme İşlemleri',
        breadcrumb: [
          {
            text: 'Ödeme Hareketleri',
            active: true,
          }
        ],
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@/views/Test.vue'),
      meta: {
        
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (Auth.isAuthenticated) {
      if(to.matched.some(record => record.meta.requiresRole)) {
        if(to.meta.requiresRole?.length > 0){
          if(Auth.hasRole(to.meta.requiresRole)) {
            next()
          } else router.push({ name: 'error-404' })
        }else next()
      } else next()
    } else router.push({ name: 'login',query:{ redirect:to.path } })
  } else next()
})

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
